<template>
    <v-card-title class="dialog-header">
        <v-btn rounded="lg" v-show="mobile" :disabled="loading" variant="outlined" icon="mdi-close"
            class="dialog-header-close-btn-mobile" @click="$emit('close')"></v-btn>
        <v-btn v-show="!mobile" icon="mdi-arrow-left" :to="/agency/ + this.customers.ownerAgency" variant="flat"></v-btn>
        <div class="dialog-header-name">
            <h1>{{ customers.name }}</h1>
        </div>
        <div class="dialog-header-buttons-right">
            <v-btn rounded="lg" :to="/agency/ + this.customers.ownerAgency" variant="outlined" class="dialog-header-navigation-buttons">Agentur</v-btn>
            <v-btn rounded="lg" v-show="!mobile" :disabled="loading" flat icon="mdi-close"
                class="dialog-header-close-btn" @click="$emit('close')"></v-btn>
        </div>
    </v-card-title>
</template>

<script>
import { mapState } from 'vuex';
import { useDisplay } from 'vuetify'

export default {
    props: {
        customers: {
            type: Object,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    computed: {
        ...mapState('customer', ['loading']),
    },
};
</script>

<style lang="scss" scoped>
.customer-dialog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;


    @media screen and (max-width: 600px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
}

.customer-dialog-header h1 {
    font-size: 32px;
}

.dialog-header-close-btn-mobile {
    margin-left: auto;
}
</style>